import { render, staticRenderFns } from "./DataListItem.vue?vue&type=template&id=d0e51ace&"
import script from "./DataListItem.vue?vue&type=script&lang=js&"
export * from "./DataListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports